import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    data: [],
};

const walletAdjustmentReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.LISTING]: (state, action) => ({
        ...state,
        rs: action.value,
    }),
    [type.DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value,
    }),
    // [type.DETAILS]: (state, action) => ({
    //     ...state,
    //     details: action.value,
    // }),
    [type.BALANCE]: (state, action) => ({
        ...state,
        memberBalc: action.value,
    }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
});

export default walletAdjustmentReducer;